import React from 'react';
import MaterialTable from 'material-table';
import { darken } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { COLORS_PROJECT } from '../../constants';


const {color_nav_letter_enc_table,color_enc_table}= COLORS_PROJECT; // color_nav,color_nav_letter

export const ReportDistanceTable = () => {

    const {data} = useSelector(state => state.print)
    const {3:redLightning,4:orangeLightning=[],5:yellowLightning=[]}= data
    const {colorPoints} = useSelector(state => state.auth) // nameAlerts
    const arrColors = colorPoints.split(",")
    //const arrNames = nameColors.split(",")
    //const arrNamesAlerts = nameAlerts.split(",")
    let red_distance,orange_distance,yellow_distance;
  
    if(redLightning===undefined){
        red_distance= 0 ;
        orange_distance= 0;
        yellow_distance= 0 ;
    }else{
        red_distance= redLightning.rayos_detectados_aoc[0].aoc ;
        orange_distance= orangeLightning.rayos_detectados_ma[0].ma ;
        yellow_distance= yellowLightning.rayos_detectados_ca[0].ca ;
    } 

    return (
        <>
            <MaterialTable
                columns = {[
                    {field: 'distancia', title: 'Area Impacto'},
                    {field: 'rayos', title: 'Total rayos detectados'},
                ]}
                data={[
                    {distancia:'Region Principal',rayos: red_distance},
                    {distancia:'Region Monitoreo',rayos: orange_distance},
                    {distancia:'Region Circundante',rayos: yellow_distance},
                ]}

                options={{
                    paging: false,
                    search: false,
                    showTitle: false,
                    toolbar: false,
                    headerStyle: {
                        backgroundColor: darken(color_enc_table,0.2),
                        color: color_nav_letter_enc_table,
                        fontWeight: 'bold',
                    },
                    rowStyle: rowData =>{
                        switch (rowData.distancia) {
                            case "Region Principal":
                                //return {backgroundColor: color_alarm_red};
                                return {backgroundColor: arrColors[3]};
                            case "Region Monitoreo":
                                //return {backgroundColor: color_alarm_orange};
                                return {backgroundColor: arrColors[2]};
                            case "Region Circundante":
                                //return {backgroundColor: color_alarm_yellow};  
                                return {backgroundColor: arrColors[1]};  
                            default:
                                return {};
                        }
                    }
                }}
            /> 
        </>
    )
}
